import type { SVGProps } from 'react';

/** Figma `tab-more.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const TabMoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <g id="Vector">
        <path d="M4 6H20ZM4 12H20ZM4 18H20Z" fill="currentColor" />
        <path
          d="M4 6H20M4 12H20M4 18H20"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </g>
    </g>
  </svg>
);
